import { Component, Input } from '@angular/core';

import { UserMonthlyUsage } from '../../../../../models/Billing/billing-details';

@Component({
    selector: 'user-monthly-usage',
    templateUrl: './user-monthly-usage.component.html',
    styleUrls: ['./user-monthly-usage.component.scss']
})
export class UserMonthlyUsageComponent {
    @Input() userMonthlyUsage: UserMonthlyUsage;
}



// WEBPACK FOOTER //
// ./src/app/main/user/user-billing/user-monthly-usage/user-monthly-usage.component.ts